import styled from 'styled-components';

export const Spacer = styled.div`
  height: 10px;
`;
